module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a6cebfe99bad7b01f59b85998cbc4628.svg";